import axios from 'axios';

import { URL_CONSTANTS } from '../../../../../constants/urlConstants';
import { Notifications } from '../../../../../constants/notification.constant';
import { updateNotificationViewed } from '../../../../shared/Topbar/Notification/Notification.service';
import { REACT_APP_ENABLE_PUSH_NOTIFICATION } from '../../../../../constants/envConstants';

export const emailReviewRead = async (messageId, type = 'review') => {
  try {
    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/email/manage/${messageId}/${type}`
    );
    let viewed = false;
    let reviewed = false;
    if (type === 'review') {
      reviewed = true;
    } else {
      viewed = true;
    }
    if (REACT_APP_ENABLE_PUSH_NOTIFICATION === true) {
      await updateNotificationViewed(
        messageId,
        Notifications.EMAIL,
        localStorage.getItem('user_id'),
        viewed,
        reviewed
      );
    }
  } catch (error) {
    console.log('Review Email Error', error);
  }
};
